import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'

import './local';
import './i18n';
import './portal.css';

import App from './App'

const win: any = window;

document.documentElement.lang = win["lang"];
const rtl = win['lang'] === 'ar';

createRoot(document.getElementById('root')!).render(
    <StrictMode>
        <App rtl={rtl}/>
    </StrictMode>,
)